<!--送培第一步 报名人员信息-->
<template>
  <div class="bg-gray">
    <div class="form-content">
      <!--      <div class="box-operate" v-if="!row.member_list.length && !loading">-->
      <!--        <el-button type="primary" icon="el-icon-plus" @click="onMemberAdd">新增人员</el-button>-->
      <!--      </div>-->


      <!-- 已有人员信息列表 -->
      <el-form
          v-if="row.member_list"
          :model="row"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <div v-for="(member,index) in row.member_list ">
          <el-divider>人员信息{{ index + 1 }}</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="'人员'+(index+1)">
                <div style="cursor: pointer" @click="memberRemove(member,index)">移除人员信息 <i
                    class="el-icon-circle-close"></i></div>
                <div class="form-label-desc" v-show="member.name">{{ member.name + '(' + member.num + ')' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="member.sex">
                  <el-radio :label="'男'">男</el-radio>
                  <el-radio :label="'女'">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="微信号" :prop="'member_list.' + index + '.weixin'"
                            :rules="[
      { required: true, message: '请输入微信号', trigger: 'blur'},
    ]">
                <el-input
                    type="text"
                    placeholder="请输入微信号"
                    v-model="member.weixin"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机" :prop="'member_list.' + index + '.phone'"
                            :rules="[
      { required: true, message: '请输入正确的手机号', trigger: 'blur'},
    ]"
              >
                <el-input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="member.phone"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>


          <div v-show="row.gametype == 3">
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否参加能力测试："
                              :rules="[
    ]">
                  <el-switch
                      v-model="member.is_join_exame"
                      active-text="是"
                      inactive-text="否"
                      active-color="#409EFF"
                      inactive-color="#ddd"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="技术等级测试项目："
                              :rules="[
    ]">
                  <el-input
                      type="text"
                      placeholder="请输入技术等级测试项目"
                      v-model="member.join_exame_name"
                  ></el-input>
                  <div class="form-label-desc mt10">技巧/花球/街舞/爵士</div>

                </el-form-item>
              </el-col>
            </el-row>

          </div>

          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="服务套餐">
                <el-radio-group v-model="member.serviceName">
                  <el-radio :label="item.name" v-for="item in row.member_list[index].service_options">{{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-for="(field,fileindex) in row.extra_field"
                    :key="fileindex">
              <el-form-item :label="field.label"
                            :prop="'member_list.' + index + '.jsondata.' +field.label"
                            :rules="[
                                { required: field.required,message:'请输入'+field.label}
    ]">
                <!--                {{member.jsondata}}-->
                <!--                {{member.jsondata[field.label]}}-->
                <!--                {{field.label}}-->
                <el-input
                    type="text"
                    :placeholder="'请输入'+field.label"
                    v-model="member.jsondata[field.label]"
                ></el-input>
                <div class="form-label-desc mt10" v-show="field.desc">{{ field.desc }}</div>
              </el-form-item>
            </el-col>
          </el-row>

        </div>

        <el-row>
          <el-col class="footer-button">
            <el-button
                plain
                size="normal" round icon="plus" @click="onMemberAdd">新增人员
            </el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存</el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <!--      新增人员信息表单 填写-->
      <el-form
          v-if="addShow"
          :model="formData"
          ref="ruleForm2"
          label-width="120px"
          class="demo-ruleForm mt10"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name"
                          :rules="[
      { required: true, message: '请输入姓名', trigger: 'blur' },
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="num"
                          v-if="formData.cardtype==1"
                          :rules="[
      { required: true, message: '请输入身份证号', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>

            <el-form-item label="证件号码" prop="huzhao"
                          v-else
                          :rules="[
      { required: true, message: '请输入证件号码', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入证件号码"
                  v-model="formData.huzhao"

              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="证件类型" prop="cardtype">
              <el-radio-group v-model="formData.cardtype">
                <el-radio :label="1">身份证</el-radio>
                <el-radio :label="2">护照</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm2('ruleForm2')" :loading="saveLoading">确定
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from "vue";
import area from "@/utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import FileUploader from "@/components/picker/FileUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

import SubjectJiaolianPicker from "@/components/picker/SubjectJiaolianPicker.vue";
import YundongyuanPicker from "@/components/picker/YundongyuanPicker.vue";

Vue.use(Cell)
    .use(CellGroup)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(ActionSheet)
    .use(RadioGroup)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(Button)
    .use(Dialog);
export default {
  name: "SongpeiApplyFormStep1",
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      radio: "男",
      loading: true,
      validator,
      playMusicUrl: "",
      thisMemberIndex: 0,
      saveLoading: false,
      showNumTypePicker: false,
      showServiceTypePicker: false,
      addShow: false,
      show_share_panel: false,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      thismember: {},
      copy_text: "cccc",
      areaValue: "",
      submitType: "",
      subject_name: "",
      subjectArray: [],
      memberrules: {
        name: [{required: true, message: "姓名不能为空"}],
        weixin: [{required: true, message: "请输入微信号"}],
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {validator: validator.phone, message: "请输入正确的手机号"},
        ],
        serviceName: [{required: true, message: "请选择人员的服务套餐"}],
        sex: [{required: true, message: "请选择人员的性别"}],
      },
      row: {
        id: 0,
        member_list: [],
        service_options: [],
        extra_field: [],
      },
      member: {
        serviceid: "",
        name: "",
        sex: "",
        weixin: "",
        phone: "",
        serviceName: "",
        service_options: [],
      },
      formData: {
        name: "",
        num: "",
        huzhao: "",
        cardtype: 1,
        numTypeName: "身份证",
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    document.title = '信息补充';
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    },
  },
  computed: {
    serviceTypeColumns() {
      return this.row.member_list[this.thisMemberIndex].service_options.map(
          (item) => {
            return item.name + "(¥" + item.price + ")";
          }
      );
    },
  },
  destroyed() {
  },
  methods: {
    onUserAdd() {
      let that = this;
      that.formData.push({
        name: "",
        type: "",
        num: "",
        edit: true,
      });
      this.addshowinf = false;
    },
    onQuestion() {
      console.log("onQuestion");
    },

    submitForm2(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          // if (that.formData.heying.length == 0) {
          //   this.$message.warning('请上传队伍照片');
          //   return
          // }
          that.saveLoading = true;
          that.$api.post("/api/songpei/checkApplyNameNum",
              {
                name: that.formData.name,
                num: that.formData.num,
                numtype: that.formData.cardtype,
                baoming_id: that.row.id,
              }, (res) => {
                that.saveLoading = false;
                let sex = '';
                if (this.formData.cardtype == 1) {
                  if (this.formData.num.substr(17, 1) % 2 == 0) {
                    sex = '男';
                  } else {
                    sex = '女';
                  }
                }

                let jsondata = {};
                if (that.row.extra_field && that.row.extra_field.length > 0) {
                  this.row.extra_field.map((field, findex) => {
                    jsondata[field.label] = '';
                  });
                }

                this.row.member_list.push({
                  name: this.formData.name,
                  num: this.formData.cardtype == 1 ? this.formData.num : this.formData.huzhao,
                  user_id: this.row.user_id,
                  baoming_id: this.row.id,
                  // service_options: res.data.service_options,
                  sex: sex,
                  jsondata: jsondata,
                })
                this.addShow = false;
              }, (res) => {
                that.$message.error(res.msg);
                that.saveLoading = false;
              })
        } else {
          console.log("error submit!!");
          return false;
        }
      });


    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    submitForm(formName) {

      let that = this;
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData)
          that.formValidate = true;
          let valiOk = true;

          if (that.row.member_list.length == 0) {
            that.$message.info('请至少新增一个人员');
            return;
          }
          console.log(that.row.member_list)
          // return
          that.row.member_list.map((item, index) => {
            if (!item.sex) {
              that.$message.info('请选择人员' + (index + 1) + '的性别');
              valiOk = false;
              return;
            }
            // if (!item.serviceName) {
            //   that.$message.info('请选择人员' + (index + 1) + '的服务套餐');
            //   valiOk = false;
            //   return;
            // }
          });
          if (!valiOk) {
            return;
          }

          that.saveLoading = true;

          that.$api.post('/api/songpei/membersave', {
                'baoming_id': that.row.id,
                'member_list': that.row.member_list.map(item => {
                  return {
                    'id': item.id || 0,
                    'name': item.name,
                    'num': item.num,
                    'danwei': this.row.danwei,
                    'sex': item.sex,
                    'phone': item.phone,
                    'weixin': item.weixin,
                    'jsondata': item.jsondata,
                    // 'footsize': item.footsize,
                    // 'csize': item.csize,
                    // 'is_join_exame': item.is_join_exame,
                    // 'join_exame_name': item.join_exame_name,
                    // 'service_id': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].id,
                    // 'price': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].price
                  }
                })
              }, (res) => {

                // if (that.row.next_gjsb) {
                //   rbLink({
                //     name: 'HuiyiApplyFormStep3',
                //     query: {
                //       id: that.row.id
                //     }
                //   })
                // } else {
                //   rbLink({
                //     name: 'HuiyiApplyFormStep5',
                //     query: {
                //       id: that.row.id
                //     }
                //   })
                //
                // }
                rbLink({
                  name:"SongpeiApplyFormSuccess",
                  query:{
                    id:res.data.id
                  }
                },'replace')
                that.saveLoading = false;
              },
              (res) => {
                that.$message.warning(res.msg);
                that.saveLoading = false;
              }
          );

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onMemberAdd() {
      this.addShow = true;
      this.formData = {
        name: '',
        num: '',
        cardtype: 1,
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      };
    },
    memberRemove(item, index) {
      let that = this;
      let notice = "确认删除" + item.name + "(" + item.num + ")" + "吗?";

      that.$confirm(notice, '确认', {
        confirmButtonText: '确认',
        closeOnPressEscape: false,
        closeOnClickModal: false,
      }).then(() => {
        if (!item.id) {
          that.row.member_list.splice(index, 1);
          return;
        }
        that.$api.post(
            "/api/songpei/memberDelete",
            {
              baoming_id: that.row.id,
              member_id: item.id,
            },
            (res) => {
              that.row.member_list.splice(index, 1);
            },
            (res) => {
              that.$message.warning(res.msg);
            }
        );
      }).catch(() => {
      });

      return
      Dialog.confirm({
        title: "确认",
        message: notice,
      })
          .then(() => {
            // on confirm
            console.log("subjectRemove");
            if (!item.id) {
              that.row.member_list.splice(index, 1);
              return;
            }
            that.$api.post(
                "/api/huiyi/memberDelete",
                {
                  baoming_id: that.row.id,
                  member_id: item.id,
                },
                (res) => {
                  that.row.member_list.splice(index, 1);
                },
                (res) => {
                  that.$message.warning(res.msg);
                }
            );
          })
          .catch(() => {
            // on cancel
          });
    },
    onNumTypeConfirm(value, index) {
      console.log(value, index)
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onServiceConfirm(value, index) {
      this.row.member_list[this.thisMemberIndex].serviceName = value;
      this.row.member_list[this.thisMemberIndex].serviceType = index + 1;
      this.showServiceTypePicker = false;
    },
    goPre() {
      let that = this;
      rbLink(
          {
            name: "SongpeiApplyFormStep1",
            query: {
              id: that.row.id,
            },
          },
          "replace"
      );
    },
    fetch() {
      let that = this;
      that.$api.post('/api/songpei/step1HalfDetail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
        that.row.member_list.map(item => {
          // item.service_options.map((service, sindex) => {
          //   if (item.service_id == service.id) {
          //     that.$set(item, 'serviceType', sindex + 1);
          //     that.$set(item, 'serviceName', service.name);
          //     return;
          //   }
          // });

          that.row.extra_field.map((field, findex) => {
            if (typeof item.jsondata[field.label] == 'undefined') {
              that.$set(item.jsondata, field.label, '');
              item.jsondata[field.label] = '';
            }
          });

        })

        that.isLoading = false;

      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    shareWeixinFriend() {
      console.log("shareWeixinFriend");
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinFriend",
          query: that.row.share_data,
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinTimeLine",
          query: that.row.share_data,
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormStep1.vue?5e3d1e2b